import React from "react";
import { Card, CardContent, Typography, Link } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";

const TotalScans = ({ totalScans = [] }) => {
    const total = totalScans.length;
    const { id: partnerId } = useParams();
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/scanhistory/${partnerId}`);
    };

    return (
        <Card sx={{ backgroundColor: "#202020", padding: "1.5rem", borderRadius: "12px" }}>
            <CardContent>
                <Typography variant="h5" sx={{ color: "#12c099" }}>Total Scans</Typography>
                <Typography variant="h4" sx={{ color: "#fff" }}>{total}</Typography>
                <Link
                    component="button"
                    onClick={handleClick}
                    sx={{ mt: 1, display: "inline-block", color: "#12c099", fontSize: "0.9rem" }}
                >
                    View Scan History
                </Link>
            </CardContent>
        </Card>
    );
};

export default TotalScans;
